export default __webpack_public_path__ + "static/media/vts.dd56c2c9.png";